export default {
  SLIGHT_ID: 1,
  MODERATE_ID: 2,
  SIGNIFICANT_ID: 3,
  NONE_ID: 4,
};
